import FeedbackPage from '@app-studio-web/ui/pages/FeedbackPage'
import { getAllAnswers } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'

export default function RoomInsightPage() {
  const { t } = useTranslation()
  const allAnswers = getAllAnswers()
  const room = allAnswers.room?.answer_key

  const isBedroom = room === 'Bedroom'
  const isKitchen = room === 'Kitchen'

  const headingKey = isBedroom
    ? 'pages.onboarding.v2.roomInsight.bedroom.heading'
    : isKitchen
      ? 'pages.onboarding.v2.roomInsight.kitchen.heading'
      : 'pages.onboarding.v2.roomInsight.default.heading'
  const textKey = isBedroom
    ? 'pages.onboarding.v2.roomInsight.bedroom.text'
    : isKitchen
      ? 'pages.onboarding.v2.roomInsight.kitchen.text'
      : 'pages.onboarding.v2.roomInsight.default.text'

  return (
    <FeedbackPage
      emoji="🏠"
      heading={t(headingKey)}
      text={t(textKey)}
      onSubmit={() => {}}
    />
  )
}
